import { ReactNode } from "react";

import { SectionRoleType, OrgRoleType } from "components/server-types";
import { t } from "i18n/i18n";
import { Tooltip } from "mds/components/Tooltip";
import { PersonSingleIcon, StarFilledIcon, StarIcon } from "mds/icons";
import { getCourseResourceRole } from "utils/section";

export type ExtendedOrgRoleType = OrgRoleType | "superuser";

// eslint-disable-next-line react-refresh/only-export-components
export const ORG_ROLE_TO_ICON: Record<ExtendedOrgRoleType, ReactNode> = {
  superuser: <StarFilledIcon />,
  admin: <StarIcon />,
  other: <PersonSingleIcon />,
  recording_agent: null,
  none: null,
};

// eslint-disable-next-line react-refresh/only-export-components
export const COURSE_ROLE_TO_ICON: Record<SectionRoleType, ReactNode> = {
  instructor: <StarIcon />,
  course_admin: <PersonSingleIcon />,
  student: <PersonSingleIcon />,
  recording_agent: null,
};

export const CourseRoleIconWithTooltip = ({
  role,
  extraContent = null,
}: {
  role: SectionRoleType;
  extraContent?: ReactNode;
}) => {
  const resourceRole = getCourseResourceRole(role);

  const content = (
    <>
      {t(`roles.course_${resourceRole}_explanation`)}
      {extraContent}
    </>
  );
  return <Tooltip text={content}>{COURSE_ROLE_TO_ICON[role]}</Tooltip>;
};

export const OrgRoleIconWithTooltip = ({
  role,
  extraContent = null,
}: {
  role: ExtendedOrgRoleType;
  extraContent?: ReactNode;
}) => {
  const content = (
    <>
      {t(`roles.org_${role}_explanation`)}
      {extraContent}
    </>
  );
  return <Tooltip text={content}>{ORG_ROLE_TO_ICON[role]}</Tooltip>;
};
